import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Coverage360 } from "@/components/Coverage360";
import { Positioning } from "@/components/Positioning";
import { CaseStudies } from "@/components/CaseStudies";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { EnquiryModal } from "@/components/EnquiryModal";

function App() {
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    const openModal = () => setModalOpen(true);

    return (
        <div className="App" id="top">
            <Navbar onOpenModal={openModal} />
            <main>
                <Hero onOpenModal={openModal} />
                <Marquee />
                <Services />
                <Coverage360 />
                <Positioning />
                <CaseStudies />
                <FinalCTA onOpenModal={openModal} />
            </main>
            <Footer />
            <EnquiryModal open={modalOpen} onOpenChange={setModalOpen} />
            <Toaster position="bottom-right" />
        </div>
    );
}

export default App;
